<!-- 首页顶部导航栏样式 -->
<template>
  <view class="nav-box" :style="{ height: height}">
    <image src="https://oss.syounggroup.com/static/file/soyoung/NewLogo/home-sycz-logo.png" class="logo" />
    <view class="nav-box-centent" :style="{height:isSearch ? '' : '40rpx'}">
      <uni-transition :mode-class="['fade']" :show="isSearch">
        <view class="search-box" v-if="isSearch" @click="goSearch">
          <text>搜索</text>
          <view class="search-btn-box">
            <view class="search-btn">搜索</view>
          </view>
        </view>
      </uni-transition>
      <uni-transition :mode-class="['fade']" :show="!isSearch">
        <text v-if="!isSearch" style="color: #999">水羊股份官方直营商城</text>
      </uni-transition>
    </view>
  </view>
</template>

<script>
import jump from '@/utils/jump';
export default {
  data() {
    return {};
  },
  props: {
    isSearch: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '',
    },
  },
  methods: {
    goSearch() {
      jump.to('/pages/search/search-index');
    },
  },
};
</script>
<style lang='scss' scoped scoped>
.logo {
  width: 146rpx;
  height: 40rpx;
  margin-right: 24rpx;
  flex-shrink: 0;
}
.nav-box {
  height: 100%;
  padding-left: 32rpx;
  font-size: 22rpx;
  display: flex;
  align-items: center;
  letter-spacing: 1rpx;
  padding-top:20rpx;
  // #ifdef MP-ALIPAY
  padding-top:40rpx;
  // #endif
  &-centent{
    display: flex;
    align-items: flex-end;
  }
}
.search-box {
  flex-shrink: 0;
  background: #F6F6F6;
  border-radius: 30px;
  color: #999;
  width: 320rpx;
  // #ifdef MP-ALIPAY
  width: 270rpx;
  // #endif
  height: 52rpx;
  line-height: 52rpx;
  padding-left: 10rpx;
  position: relative;
  font-size:24rpx;
  padding-left:28rpx;
  .search-btn-box{
    position: absolute;
    width: 110rpx;
    height: 50rpx;
    right:0;
    top:0;
    display: flex;
    justify-content: center;
    align-items: center;
    .search-btn {
      height:42rpx;
      width: 100rpx;
      // #ifdef MP-ALIPAY
      height:44rpx;
      width: 102rpx;
      // #endif
      display: flex;
      justify-content: center;
      align-items: center;
      background: #D70909;
      border-radius: 26rpx;
      color:#fff;
    }
  }
}
</style>
